import { formatMoney } from "../utilities";

const PriceDisplay = {
  addUnavailable: function (element, isMainProduct) {
    if (!element) return;

    const soldOutEl = element.querySelector('.sold-out');

    if (!soldOutEl) {
      const tagToCreate = isMainProduct ? 'h2' : 'p';

      const newElement = document.createElement(tagToCreate);
      newElement.classList.add('sold-out');
      newElement.innerHTML = 'Indisponível';

      //No produto principal, exibe apenas o preço principal e o texto "Indisponível"
      //No product block e compra rápida, exibe apenas o texto "Indisponível"
      if (!isMainProduct) {
        element.innerHTML = '';
      }

      element.appendChild(newElement);
    }
  },

  addPercentage: function(element ,variant) {
    if (!variant.on_sale) return;

    const newElement = document.createElement('p');
    newElement.classList.add('percentage');
    newElement.innerHTML =
      `${`${100 - ((variant.sale_price / variant.price) * 100)}`.split('.')[0]}% OFF`

    element.appendChild(newElement);
  },

  addPrice: function (element, variant, HTMLtag) {
    const newElement = document.createElement(HTMLtag);
    newElement.classList.add('price');

    if (!variant.available) {
      newElement.classList.add('sold-out-price');
    }
    
    newElement.innerHTML = variant.on_sale
      ? `<del>${formatMoney(variant.price)}</del><ins>${formatMoney(variant.sale_price)}</ins>`
      : `<span>${formatMoney(variant.price)}</span>`;

    element.appendChild(newElement);
  },

  addInstallments: function(element, variant, showWithInterest = true, showWithoutInterest = true) {
    if (!variant.installments.length) return;

    // Verifica o tipo de parcelamento
    const withInterest = variant.installments;
    const withoutInterest = variant.installments.filter(ins => !ins.interest);

    if (!withoutInterest.length && !withInterest.length) return;

    let installmentsHtml = '';


    // Modifica os textos de parcelamento baseado nos parametros da função
    if (showWithoutInterest && withoutInterest.length) {
      installmentsHtml += `<span>em ${withoutInterest.length}x de <strong>${formatMoney(withoutInterest[withoutInterest.length - 1].price)}</strong> sem juros</span>`;
    }

    if (showWithInterest && withInterest.length) { 
      installmentsHtml += `<span>${installmentsHtml ? 'ou' : ''} em ${withInterest.length}x de <strong>${formatMoney(withInterest[withInterest.length - 1].price)}</strong> com juros</span>`;
    }

    // Cria e insere o elemento
    if (installmentsHtml) {
      const newElement = document.createElement('p');
      newElement.className = 'installments';
      newElement.innerHTML = installmentsHtml;
      element.appendChild(newElement);
    }
  },

  addPIX: function(element, variant, type) {
    if (!pixDiscount) return;

    const newElement = document.createElement('p');
    newElement.classList.add('pix');
    newElement.innerHTML =
      type == 'block'
        ? `${formatMoney(variant.sale_price - (variant.sale_price / 100 * pixDiscount))} no PIX`
        : `${formatMoney(variant.sale_price - (variant.sale_price / 100 * pixDiscount))} no PIX com ${pixDiscount}% de desconto`
  
    element.appendChild(newElement);
  },

  addCashback: function(element, variant, type) {
    if (!variant.cashback || !variant.cashback.percentage || variant.cashback.percentage == 0) return;

    const newElement = document.createElement('p');
    newElement.classList.add('cashback');
    newElement.innerHTML =
      type == 'block'
        ? `${formatMoney(variant.sale_price / 100 * variant.cashback.percentage)} de cashback!`
        : `Ganhe até ${formatMoney(variant.sale_price / 100 * variant.cashback.percentage)} de cashback!`
  
    element.appendChild(newElement);
  },

  addPreSale: function(price, type) {
    const priceEl = price.querySelector('.price');
    const product = price.closest('[data-product-box]');
    const element = product.querySelector('[data-pre-sale]');
    let text = 'Preço de pré-venda';

    if(!element) return

    if(element.hasAttribute('data-pre-sale-text')) text = element.getAttribute('data-pre-sale-text');

    if(type == 'main') {
      const flag = document.createElement('div');
      flag.classList.add('flag-pre-sale');
      flag.innerHTML = `<svg class="icon"><use xlink:href="#icon-timer"/></svg> ${text}`;

      priceEl.append(flag);

      const button = product.querySelector('.add-to-cart-button');
      const buttonText = button.getAttribute('data-text-pre-sale');

      if (button && product.classList.contains('-pre-sale')) {
        button.innerHTML = buttonText; // Botão comprar com texto pré venda
      }
    } else {
      element.classList.remove('-hidden');
    }
  },

  productMain: function (element, variant) {
    const showWithInterest = true;
    const showWithoutInterest = true;

    element.innerHTML = '';
    
    if (!variant.available) {
      PriceDisplay.addPrice(element, variant, 'h2');
      return;
    }

    PriceDisplay.addPercentage(element, variant);
    PriceDisplay.addPrice(element, variant, 'h2');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
    PriceDisplay.addPIX(element, variant, 'main');
    PriceDisplay.addCashback(element, variant, 'main');
    PriceDisplay.addPreSale(element, 'main');
  },

  productBlock: function(element, variant) {
    const showWithInterest = true;
    const showWithoutInterest = true;

    element.innerHTML = '';

    PriceDisplay.addPrice(element, variant, 'p');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
    PriceDisplay.addPIX(element, variant, 'block');
    PriceDisplay.addPreSale(element, 'block');
  },
}

export default PriceDisplay
